import { defineMessages, FormattedMessage, type MessageDescriptor } from 'react-intl'
import { CRUISE_PROMOTION_FOUR_PEOPLE } from 'lib/cruises/cruiseUtils'

interface Props {
  promotion?: string
  cabinType?: string
}

const promotionLabels: Record<string, MessageDescriptor> = defineMessages({
  [CRUISE_PROMOTION_FOUR_PEOPLE]: {
    id: 'kpYnSVE1q2JtTSgeli7P',
    defaultMessage: 'Family of 4 from',
  },
})

export default function CruisePriceFromLabel({ promotion, cabinType }: Props) {
  const promotionLabel = promotion ? promotionLabels[promotion] : undefined

  if (promotion === CRUISE_PROMOTION_FOUR_PEOPLE && cabinType) {
    return <FormattedMessage
      id="EeYfvyMGi_3XeWQYui4S"
      defaultMessage="Family of 4 {cabinType} from"
      
      values={{ cabinType }}
    />
  }

  if (promotionLabel) return <FormattedMessage {...promotionLabel} />

  if (cabinType) {
    return <FormattedMessage
      id="OWqPk_LWR750wyY4ehdh"
      defaultMessage="{cabinType} from"
      
      values={{ cabinType }}
    />
  }

  return <FormattedMessage
    id="_i1oXTT5R-RrHGEZFIar"
    defaultMessage="From"
    
  />
}
